// Darby Solutions JavaScript
import lightGallery from "lightgallery";
let ClassicEditor = require('@ckeditor/ckeditor5-build-classic');
import * as Darby from './darby_alerts';
import lgZoom from "lightgallery/plugins/zoom";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgFullscreen from "lightgallery/plugins/fullscreen";
import lgVideo from "lightgallery/plugins/video";
import jszip from 'jszip';
import pdfmake from 'pdfmake';
import DataTable from 'datatables.net-bs5';
import 'datatables.net-autofill-bs5';
import 'datatables.net-buttons-bs5';
import 'datatables.net-buttons/js/buttons.colVis.mjs';
import 'datatables.net-buttons/js/buttons.html5.mjs';
import 'datatables.net-buttons/js/buttons.print.mjs';
import 'datatables.net-colreorder-bs5';
import DateTime from 'datatables.net-datetime';
import 'datatables.net-fixedcolumns-bs5';
import 'datatables.net-fixedheader-bs5';
import 'datatables.net-keytable-bs5';
import 'datatables.net-responsive-bs5';
import 'datatables.net-rowgroup-bs5';
import 'datatables.net-rowreorder-bs5';
import 'datatables.net-scroller-bs5';
import 'datatables.net-searchbuilder-bs5';
import 'datatables.net-searchpanes-bs5';
import 'datatables.net-select-bs5';
import 'datatables.net-staterestore-bs5';

/*** Utility ***/
(function() {
  // automatic alertModals
  $('.alertModal').each(function(index){
    Darby.alertModal($(this).text());
  });

  $('#dialog').each(function(index){
    Darby.testModal();
  });


})();

/*** Searches ***/

(function() {
  // autofill parameters
  $.fn.dataTable.AutoFill.actions.names = {
    available: function ( dt, cells ) {
      // Only available if a single column is being
      // filled and it is the first column
      return cells[0].length === 1 && cells[0][0].index.column === 0;
    },

    option: function ( dt, cells ) {
      // Ask the user if they want to change the surname only
      return 'Fill only surname - retain first name';
    },

    execute: function ( dt, cells, node ) {
      // Modify the name and set the new values
      let surname = cells[0][0].data.split(' ')[1];

      for ( let i=0, ien=cells.length ; i<ien ; i++ ) {
        let name = cells[i][0].data.split(' ');

        cells[i][0].set = name[0]+' '+surname;
      }
    }
  };
  $.fn.dataTable.AutoFill.actions.names = {
    available: function ( dt, cells ) {
      // Only available if a single column is being
      // filled and it is the first column
      return cells[0].length === 1 && cells[0][0].index.column === 0;
    },

    option: function ( dt, cells ) {
      // Ask the user if they want to change the surname only
      return 'Fill only surname - retain first name';
    },

    execute: function ( dt, cells, node ) {
      // Modify the name and set the new values
      let surname = cells[0][0].data.split(' ')[1];

      for ( let i=0, ien=cells.length ; i<ien ; i++ ) {
        let name = cells[i][0].data.split(' ');

        cells[i][0].set = name[0]+' '+surname;
      }
    }
  };
  // defaults for all dataTables
  $.extend( $.fn.dataTable.defaults, {
    info: true, // showing x of y number of rows
    paging: true,
    pageLength: 100,
    lengthMenu: [25, 100, 500, { label: 'All', value: -1 }], // page length
    searching: true,
    colReorder: true,
    rowReorder: { // drag by first column. this makes the first column unselectable. use selector instead.
      selector: 'span.reorder'
    },
    /*
    rowGroup: {
      dataSrc: 5
    },
    */
    ordering: true,
    select: true, // selection of rows
    keys: { // excel like selection of cells. Needs its own css to work.
      columns: '', // array of zero based columns, empty string for all, ':not(:last-child)'
    },
    autoFill: { // fill range of cells with specified values. autoFill needs to follow keys. Needs its own css to work.
      alwaysAsk: true, // brings up dialog box instead of immediately copying the first element
      focus: 'focus', // drag copy dot doesn't show up until focus, hover or click. Needs to be focus for keyTable
    },
    responsive: false, // removes columns if they don't fit on the screen
    lengthChange: true, // shrinks the table if not enough rows
    //caption: 'Example Table', // title of table
    processing: true, // does a wait icon while it is processing or fetching ajax data
    scrollX: true,
    stateSave: true, // refresh keeps settings
    orderMulti: true, // sort by multiple columns with shift select
    buttons: ['copy', 'csv', 'excel', 'pdf', 'print'],
    layout: {
      topStart: 'search',
      topEnd: 'pageLength',
      bottomStart: 'paging',
      bottomEnd: 'buttons',
      bottom2start: 'info',
    }
  } );
  // activate data table(s)
  $('.js_dt_table').DataTable();
  // table events
  /*
  table.on('click', 'tbody tr', function () {
    let data = table.row(this).data();

    alert('You clicked on ' + data[0] + "'s row");
  });
  */

  let xhr;

  function getContactInfo(searchString){
    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
    if(xhr && xhr.readyState != 4){ /* 4 is Done */
      xhr.abort();
    }
    xhr = $.ajax(
      {
        /* the route pointing to the post function */
        url: '/phones/search_contact',
        type: 'POST',
        /* send the csrf-token and the input to the controller */
        data: {
          _token: CSRF_TOKEN,
          search_string: searchString,
        },
        dataType: 'json',
        /* remind that 'data' is the response of the AjaxController */
        success: function ( data, textStatus, jqXHR) {
          //console.log(jqXHR);
          if (data.full_name) {
            $('#full_name').val(data.full_name);
          }
          if (data.email) {
            $('#email').val(data.email);
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.log(textStatus);
          console.log(errorThrown);
          // console.log(jqXHR);
        }
      }
    );
  }

  function getSearch(){
    /*
      class .search - every .search would have a keyup event triggered to activate the search
      val() of .search - the search string used
      #tag_list button.badge-success - ids are sent to search
      model and search_type - url: '/' + model + '/' + search_type for controller method
      result_type - output of search like list, buttons, table...
      #results_id - ID of element to get the results html
      field_name - name to use in output results. Like entity_id for a search of entities in a search list.
      field_name and field_value
        - To have a separate search criteria like event_id = 1234 and rest of search for within that event.
        - For lists, specifies the selected entity
        - field_name = has_entity_id - Get models associated with entity like $entity->events
      all_results_null - Display all models instead of no models if no search string
      page - for pageable results page_size - number of items per page
      page_size - number of results per page
    */
    let CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
    let search_string = $(this).val();
    let search_type = $(this).data('search_type');
    let results_type = $(this).data('results_type');
    let results_id = $(this).data('results_id');
    let all_results_null = $(this).data('all_results_null');
    let model = $(this).data('model');
    let field_name = $(this).data('field_name');
    let field_value = $(this).data('field_value');
    if (search_string === '' && !all_results_null && field_value === ''){
      $('#' + results_id).html('');
      return;
    }
    let page = $(this).data('page');
    let page_size = $(this).data('page_size');
    let tag_ids = $("#tag_list button.badge-success").map(function(){
      return $(this).val();
    }).get();
    if(search_string.length > 1 && xhr && xhr.readyState != 4){ /* 4 is Done */
      xhr.abort();
    }
    xhr = $.ajax(
      {
        /* the route pointing to the post function */
        url: '/' + model + '/' + search_type,
        type: 'POST',
        /* send the csrf-token and the input to the controller */
        data: {
          _token: CSRF_TOKEN,
          search_string: search_string,
          results_type: results_type,
          all_results_null: all_results_null,
          model:  model,
          field_name: field_name,
          field_value: field_value,
          page: page,
          page_size: page_size,
          tags: tag_ids,
        },
        dataType: 'json',
        /* remind that 'data' is the response of the AjaxController */
        success: function ( data, textStatus, jqXHR) {
          //console.log(jqXHR);
          $('#' + results_id).html(data.html);
          if (results_type === 'dt_table') {
            $('#' + results_id + ' table').DataTable();
          }
          $('#' + results_id + ' .lightgallery').each(function(){
            lightGallery(this, {
              plugins: [lgZoom, lgThumbnail, lgFullscreen, lgVideo],
              licenseKey: '`0000-0000-000-0000',
              selector: '.light_item',
              animateThumb: true,
              fullScreen: true,
              speed: 500,
            });
          })

        },
        error: function (jqXHR, textStatus, errorThrown) {
          //console.log('Get Search Error')
          console.log(textStatus);
          console.log(errorThrown);
          // console.log(jqXHR);
        }
      }
    );
  }

  function setUse(event) {
    const field = '#use_' + $(this).data('model');
    $(field).val($(this).data('model_id'));
  }

  // Events
  // ======
  const transferTicketForm = document.getElementById('transfer_ticket_form');
  if (transferTicketForm) {
    $('#display_number').keyup(function (event) {
      const numbers = $(this).val().replace(/[^0-9]/g, '');
      if (numbers.length > 9) {
        getContactInfo($(this).val());
      }
    });
  }

  $(document).on('click', '.set-use', setUse);

  $('.search').on('keydown', function (){$(this).data('page', 1)})
    .on('keyup', getSearch);

  $(document).on('click', '.pagination a', function (event) {
    event.preventDefault();
    const pathComponents = $(this).attr('href').split('/');
    const model = pathComponents[pathComponents.length - 2];
    const selectString = '.search[data-model='+'"' + model + '"'+']';
    let page = $(this).attr('href').split('page=')[1];
    $(selectString).data('page', page)
      .trigger('keyup');
  });

  $('#tag_list button.badge').click(function () {
    if ($(this).attr('class') == 'badge badge-pill badge-secondary'){
      $(this).attr('class', 'badge badge-pill badge-success');
    } else {
      $(this).attr('class', 'badge badge-pill badge-secondary');
    }
    $('.search').data('page', 1)
      .trigger('keyup');
  });

  // Load initial results
  $('.search').data('page', 1)
    .trigger('keyup');

})();

/*** Contact Wizard ***/

(function() {

  function formatPhoneNumber(event) {
    const phoneNumberString = $(this).val();
    const numbers = phoneNumberString.replace(/[^0-9]/g, '');
    let formattedNumber = phoneNumberString;
    // Do not format if first character is a space
    const lastCharacter = formattedNumber[formattedNumber.length - 1];
    if (formattedNumber[0] != ' '
      && lastCharacter != '-'
      && lastCharacter != ' '
      && lastCharacter != 'x') {
      if (numbers.length > 10){
        formattedNumber = numbers.slice(0,3) + '-' + numbers.slice(3,6) + '-' + numbers.slice(6,10) + ' x' + numbers.slice(10);
      } else if (numbers.length > 6){
        formattedNumber = numbers.slice(0,3) + '-' + numbers.slice(3,6) + '-' + numbers.slice(6,10);
      } else if (numbers.length > 3){
        formattedNumber = numbers.slice(0,3) + '-' + numbers.slice(3,6);
      } else {
        formattedNumber = numbers;
      }
    }
    $(this).val(formattedNumber);
  }
  $(document).on('keyup', '#display_number', formatPhoneNumber);

  function setNames() {
    let full_name = $('#full_legal_name').val() || $('#full_birth_name').val() || $('#short_legal_name').val() || $('#preferred_name').val();
    if (full_name){full_name = full_name.trim();}
    let full_birth_name = $('#full_birth_name').val() || full_name;
    if (full_birth_name){full_birth_name = full_birth_name.trim();}
    let short_name = $('#short_legal_name').val();
    if (short_name){short_name = short_name.trim();}
    let preferred_name = $('#preferred_name').val();
    if (preferred_name){preferred_name = preferred_name.trim();}
    if (full_name) {
      if (full_birth_name && full_birth_name.indexOf(' ') == -1 && full_name.indexOf(' ') != -1) {
        full_birth_name = full_birth_name + full_name.substr(full_name.lastIndexOf(' '));
      }
      if (!short_name) {
        if (full_name.indexOf(' ') != -1) {
          short_name = full_name.substr(0, full_name.indexOf(' ')) + full_name.substr(full_name.lastIndexOf(' '));
        } else {
          short_name = full_name;
        }
      }
      if (short_name && short_name.indexOf(' ') == -1 && full_name.indexOf(' ') != -1) {
        short_name = short_name + full_name.substr(full_name.lastIndexOf(' '));
      }
      if (!preferred_name) {
        preferred_name = short_name
      }
      if (preferred_name && preferred_name.indexOf(' ') == -1 && full_name.indexOf(' ') != -1) {
        preferred_name = preferred_name + full_name.substr(full_name.lastIndexOf(' '));
      }
      $('#full_legal_name').val(full_name)
      $('#full_birth_name').val(full_birth_name)
      $('#short_legal_name').val(short_name);
      $('#preferred_name').val(preferred_name);
    }
  }

  $('#full_legal_name').focusout(function () {
    setNames();
  });
  $('#full_birth_name').focusout(function () {
    setNames();
  });
  $('#short_legal_name').focusout(function () {
    setNames();
  });
  $('#preferred_name').focusout(function () {
    setNames();
  });
  // setNames();

  function setChecks() {
    const fieldset_id = $(this).closest('fieldset').attr('id');
    const lists = '#' + fieldset_id + ' input.subscribe_lists';
    const lists_checked = '#' + fieldset_id + ' input.subscribe_lists:checked';
    const everything = '#' + fieldset_id + ' input.everything_list';
    const nothing = '#' + fieldset_id + ' input.nothing_list';
    const clicked_id = $(this).attr('id');
    if (clicked_id == $(everything).first().attr('id')){
      if ($(everything).first().prop('checked')){
        // Check all lists except nothing
        $(lists).prop('checked', true);
        $(nothing).prop('checked', false);
      }
    } else if (clicked_id == $(nothing).first().attr('id')) {
      if ($(nothing).first().prop('checked')){
        // Uncheck all lists including everything
        $(lists).prop('checked', false);
        $(everything).prop('checked', false);
      }
    }
    $(everything).prop('checked', ($(lists).length == $(lists_checked).length));
    $(nothing).prop('checked', ($(lists_checked).length == 0));
  }

  $(document).on('click', '#email_preference input', setChecks);
  $(document).on('click', '#text_preference input', setChecks);

  if ($('#email_preference input').length > 0 && $('#email_preference input:checked').length == 0){
    $('#email_preference input').prop('checked', true);
    $('#email_preference input.nothing_list').prop('checked', false);
  }
  if ($('#text_preference input').length > 0 && $('#text_preference input:checked').length == 0){
    $('#text_preference input').prop('checked', true);
    $('#text_preference input.nothing_list').prop('checked', false);
  }

})()

// CK Editor - Size is set via style
$('.ckeditor').each(function(index) {
  ClassicEditor
    .create(this)
    .then(editor => {
      console.log(editor);
    })
    .catch(error => {
      console.error(error);
    });
});

// jQuery UI calendar
$( ".birthday" ).datepicker({
  dateFormat: "yy-mm-dd",
  changeMonth: true,
  changeYear: true,
  defaultDate: "-65y",
  maxDate: "-1",
  yearRange: "-100:+1",
  onChangeMonthYear: function (year, month, inst) {
    var date = $(this).val();
    if ($.trim(date) !== "") {
      var newDate = month + "/" + inst.currentDay + "/" + year;
      $(this).val($.datepicker.formatDate('yy-mm-dd', new Date(newDate)));
    }
  }
});

// Wait on submits
document.addEventListener("DOMContentLoaded", function() {
  const mainForm = document.getElementById('main-form');
  const cardButton = document.getElementById('submit-button');
  const cardWait = document.getElementById('card-wait');
  // const paymentForm = document.getElementById('payment-form');
  if (mainForm) {
    mainForm.addEventListener('submit', async (e) => {
      cardButton.style.display = 'none';
      cardWait.style.display = 'block';
    });
  }
});

(function() {
  function getHostName(url) {
    var a = document.createElement('a');
    a.href = url;
    var host = a.hostname.toLowerCase();
    a = null; // Explicitly remove reference to the element
    return host;
  }

  window.Echo.channel('darby-pos')
    .listen('NewOrder', newOrder => {
      //console.log('New Order notice received.');
      if (getHostName(newOrder.app_url) === getHostName($(location).attr('host'))) {
        let $alertBody = $('.order_alert');
        if ($alertBody.length > 0) {
          $alertBody.addClass('new-order');
          $('.orders_search').trigger('keyup');
          const audio = new Audio('/storage/media/331410998.wav');
          audio.loop = true;
          audio.play();
          //console.log(newOrder);
        }
      }
    })
    .listen('Arrived', arrived => {
      if (getHostName(arrived.app_url) === getHostName($(location).attr('host'))) {
        let $alertBody = $('.order_alert');
        if ($alertBody.length > 0) {
          $alertBody.addClass('arrived');
          $('.orders_search').trigger('keyup');
          const audio = new Audio('/storage/media/331410998.wav');
          audio.loop = true;
          audio.play();
          $('#messages').append('<div class="alert alert-danger text-center">Order #' + arrived.message.model_id + ': ' + arrived.message.description + '</div>');
          //console.log('Order #' + arrived.message.model_id + ': ' + arrived.message.description);
          //console.log(arrived);
        }
      }
    })
  ;

})();


